import React from 'react';
import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, TextField } from '@mui/material';
import PropTypes from 'prop-types';

const AlertDialog = (props) => {
  const {
    color = 'primary',
    size = 'small',
    style = null,
    btnString,
    disabled = false,
    title,
    description,
    disagreeBtnStr = 'Disagree',
    agreeBtnStr = 'Agree',
    handleAgree,
    sendMessage = true,
  } = props;
  const [open, setOpen] = React.useState(false);
  const [error, setError] = React.useState(false);
  const [errorText, setErrorText] = React.useState(null);
  const [remark, setRemark] = React.useState('');

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleAgreeAction = () => {
    if (sendMessage && !remark.length) {
      setError(true);
      setErrorText('Remark cannot empty');
      return false;
    }
    setOpen(false);
    handleAgree(remark);
  };

  const remarkOnchange = (e) => {
    setError(false);
    setRemark(e.target.value);
  };

  return (
    <React.Fragment>
      <Button variant="contained" disabled={disabled} size={size} color={color} style={style} onClick={handleClickOpen}>
        {btnString}
      </Button>
      <Dialog open={open} onClose={handleClose} aria-labelledby="alert-dialog-title" aria-describedby="alert-dialog-description">
        <DialogTitle id="alert-dialog-title">{title}</DialogTitle>
        {sendMessage && (
          <DialogContent>
            <DialogContentText id="alert-dialog-description">{description}</DialogContentText>
            <TextField error={error} required label="Type a message" fullWidth helperText={errorText} onChange={remarkOnchange} />
          </DialogContent>
        )}
        <DialogActions>
          <Button onClick={handleClose} color="primary">
            {disagreeBtnStr}
          </Button>
          <Button onClick={handleAgreeAction} color="primary" autoFocus>
            {agreeBtnStr}
          </Button>
        </DialogActions>
      </Dialog>
    </React.Fragment>
  );
};

AlertDialog.propTypes = {
  color: PropTypes.string,
  size: PropTypes.string,
  style: PropTypes.object,
  disabled: PropTypes.bool,
  disagreeBtnStr: PropTypes.string,
  agreeBtnStr: PropTypes.string,
  btnString: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
  handleAgree: PropTypes.func.isRequired,
  sendMessage: PropTypes.bool,
};

export default AlertDialog;
